module.exports = __webpack_public_path__ + "img/pc_04.0c72b312.png";